import script from "./StructureEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureEditor.vue?vue&type=script&setup=true&lang=js"

import "./StructureEditor.vue?vue&type=style&index=0&id=6f83f23a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f83f23a"]])

export default __exports__